import { z } from 'zod';

const schFile = z.instanceof(File);

export const schCertifyModalForm = z.object({
  certificationCommentary: z.string().optional(),
  signatureFile: schFile.optional(),
  useAccountSignature: z.boolean().default(false),
  stateSealFile: schFile.optional(),
  saveSignature: z.boolean().default(true),
});
export type CertifyModalFormOutput = z.infer<typeof schCertifyModalForm>;
export type CertifyModalForm = typeof schCertifyModalForm;
